// import axios from '@core/axios/axios.js'

const API = {
  forgotPasswordResource: '/auth/forgot-password',
  resetPasswordResource: '/auth/reset-password',

  account: '/account',
  subaccountResource: '/account/subaccounts',
  deleteSubaccountResource: '/account/subaccounts/:id',

  clientCreditsResource: '/account/credits',

  paymentProfilesResource: '/account/payment-profiles',
  deletePaymentProfileResource: '/account/payment-profiles/:id',

  newsroomsResource: '/account/newsrooms',
  newsroomPressReleasesResource: '/newsroom-groups/:id/press-releases',

  getOrdersResource: '/orders',
  getOrderResource: '/orders/:id',
  lastIncompleteOrderResource: '/orders/last-incomplete-order',
  startOrderResource: '/orders/start',
  updateOrderResource: '/orders/:id?_method=PATCH',

  packagesResource: '/packages',
  packageResource: '/packages/:slug',

  getIndustryTargetsResource: '/industry-targets',
  getInfluencerListsResource: '/influencers',

  getDistributionCountriesResource: '/distribution-countries',

  getLocalAreasResource: '/local-areas',

  getUserAccountResource: '/account',
  packageGroupsResource: '/account/package-groups',

  payOrderResource: '/orders/:id/pay',

  getOrderRatingResource: '/order-rating',
  surveyFormResource: '/account/survey-form',

  experienceRatingResource: '/orders/:id/experience-rating',
  leaveReviewResource: '/orders/:id/review',

  countriesResource: 'geo/countries',
  statesResource: 'geo/states',
  stateResource: 'geo/states/:id',

  blackoutDates: '/blackout-dates',

  healthReadyResource: '/health/ready',
}

export default API
